import script from "./details.vue?vue&type=script&setup=true&lang=ts"
export * from "./details.vue?vue&type=script&setup=true&lang=ts"

import "./details.vue?vue&type=style&index=0&id=c6209d92&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6209d92"]])

export default __exports__